module.exports = __webpack_public_path__ + "img/z.37a8c47c.jpg";